<script lang="ts" setup>
import { ref } from 'vue';
import MenuIcon from 'vue-ionicons/dist/ios-menu.vue';
import CloseIcon from 'vue-ionicons/dist/ios-close.vue';

const isMenuOpen = ref(false);

const toggleMenu = () => {
    isMenuOpen.value = !isMenuOpen.value;
};
</script>

<template>
    <div class="absolute w-dvw h-svh">
        <nav class="absolute top-1 left-1 z-20">
            <button id="MenuBtn" type="button" @click="toggleMenu" class="flex items-center justify-start px-2 uppercase font-bold h-[40px] rounded-[5px] text-[1.5em]"><MenuIcon v-if="!isMenuOpen" class="text-[1.5em]" /><CloseIcon v-else class="text-[1.5em]" /> Menu</button>
        </nav>
        <div id="Menu" class="absolute inset-2 z-10 isolate pt-[40px] rounded-[5px] overflow-hidden transition-all duration-1000" :class="{'w-[calc(100%-1em)] h-[calc(100%-1em)]': isMenuOpen, 'w-0 h-0': !isMenuOpen}">
            <div class="w-full h-full grid grid-cols-1 px-4 pb-4">
                <div>
                    <nav class="flex flex-col gap-y-8 py-4">
                        <ul class="flex flex-col gap-y-2 font-bold uppercase text-[1.2em]">
                            <li><router-link @click="toggleMenu" class="text-[#12FF15] hover:text-red-400 transition-colors duration-500 whitespace-nowrap" to="/">Strona Główna</router-link></li>
                            <li><router-link @click="toggleMenu" class="text-[#12FF15] hover:text-red-400 transition-colors duration-500 whitespace-nowrap" to="/map">Mapa (BETA)</router-link></li>
                        </ul>
                        <ul class="flex flex-col gap-y-2 font-bold uppercase text-[1.2em]">
                            <li><a class="text-[#12FF15] hover:text-red-400 transition-colors duration-500 whitespace-nowrap" href="https://pustkowia.org">Pustkowia Winków</a></li>
                            <li><a class="text-[#12FF15] hover:text-red-400 transition-colors duration-500 whitespace-nowrap" href="https://winkonet.pustkowia.org">Winko.NET</a></li>
                        </ul>
                    </nav>
                </div>
                <div class="place-self-end flex items-center gap-x-4 whitespace-nowrap uppercase font-bold text-[#12FF15] bg-black/20 px-4 py-2 rounded-[5px]">Stronę oraz materiały wykonał Anton Sokolov <span class="text-[.2em]">(z drobną pomocą AI)</span></div>
            </div>
        </div>
        <div id="Main" class="absolute w-full h-full z-0 isolate px-4 pb-4 pt-[40px]">
            <router-view/>
        </div>
    </div>
</template>

<style lang="scss">
@font-face {
    font-family: 'Rajdhani';
    src: url('~@/assets/rajdhaniregular.ttf') format('truetype');
    font-weight: normal;
}

@font-face {
    font-family: 'Rajdhani';
    src: url('~@/assets/rajdhanibold.ttf') format('truetype');
    font-weight: bold;
}

* {
    font-family: Rajdhani, Calibri, Georgia;
}

::selection {
    background-color: #12FF15;
    color: #111;
}

body {
    background-color: #111;
}

#Menu {
    background-color: #111;
}

#Main {
    background-image: url('~@/assets/bg.jpg');
    background-size: cover;
    background-position-y: center;
    background-position-x: center;
}

#MenuBtn {
    background-color: #12FF15;
}
</style>